import { useEffect, useState, useHistory, useGlobalState, } from "@discovery/common-dplus/lib/hooks";
import { pushHeaderMenuClickEvent } from "@discovery/common-dplus/lib/adobe";
import { cn } from "@discovery/classnames";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { NavigationItem, } from "../../molecules/navigation-item";
import { HomeRoute } from "../nav-bar";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { memo } from "react";
export const Navigation = memo(({ navigationItems }) => {
    const [changes] = useHistory();
    const path = changes.location.pathname;
    const [selectedRoute, setRoute] = useGlobalState(HomeRoute);
    const [selectedMenuUrl, setSelectedMenuUrl] = useState(path === "/" ? config.standardPageRouteFragments.home : path);
    const watchQueryParams = () => {
        setSelectedMenuUrl(window.location.pathname);
        setRoute(window.location.pathname);
    };
    useEffect(() => {
        window.addEventListener("popstate", watchQueryParams);
        return function cleanUp() {
            window.removeEventListener("popstate", watchQueryParams);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const analyticsEvent = (item, index) => {
        const indexValue = index + 1;
        const itemPosition = indexValue.toString();
        const currentPathName = window.location.pathname === "/"
            ? config.standardPageRouteFragments.home
            : window.location.pathname;
        const locationUrl = window.location.pathname === "/"
            ? "www.discoveryplus.in/home"
            : window.location.href;
        pushHeaderMenuClickEvent(currentPathName, itemPosition, item.title, "menu", locationUrl, item.url);
    };
    const onTabChange = (item, index) => {
        setRoute(item.url);
        setSelectedMenuUrl(item.url);
        analyticsEvent(item, index);
    };
    const isSelectedRoute = (route) => {
        if (!(path === config.standardPageRouteFragments.home ||
            path === "/explore" ||
            path === "/explore-v4" ||
            path === "/shorts" ||
            path === "/mindblown" ||
            path === "/premium" ||
            path === "/go-premium-web" ||
            path === "/" ||
            path === "/kids/home" ||
            path === "/channel/mindblown" ||
            path === "/go-premium-v2")) {
            return false;
        }
        else if (selectedMenuUrl &&
            selectedMenuUrl === route &&
            selectedRoute !== config.standardPageRouteFragments.home &&
            path === route &&
            path !== "/channel/mindblown") {
            return true;
        }
        else if (selectedMenuUrl === "/" &&
            route === config.standardPageRouteFragments.home) {
            return true;
        }
        else if ((route === config.standardPageRouteFragments.home &&
            path === config.standardPageRouteFragments.home) ||
            (route === config.standardPageRouteFragments.home && path === "/")) {
            return true;
        }
        else if (route === "/mindblown" && path === "/channel/mindblown") {
            return true;
        }
        else if (route === config.standardPageRouteFragments.goPremium &&
            path === route) {
            return true;
        }
        else {
            return false;
        }
    };
    const navList = navigationItems.map((item, index) => {
        const selected = isSelectedRoute(item.url);
        return (React.createElement(NavigationItem, { title: item.title, type: item.type, src: item.src, altSrc: item.altSrc, isSelected: selected, url: item.url, onClickM: M.of(() => onTabChange(item, index)), key: index }));
    });
    if (path === config.standardPageRouteFragments.home ||
        path === "/explore" ||
        path === "/explore-v4" ||
        path === "/shorts" ||
        path === "/mindblown" ||
        path === "/premium" ||
        path === "/go-premium-web" ||
        path === "/" ||
        path === "/kids/home" ||
        path === "/go-premium-v2") {
        return (React.createElement(React.Fragment, null, window.innerWidth > 699 ? (React.createElement("div", { className: cn(styles.hideMenuD, styles.container), id: "#menubar" }, navList)) : (React.createElement("div", { className: cn(styles.container, styles.hideMenuM), id: "#bottombar" }, navList))));
    }
    else {
        return (React.createElement("div", { className: cn(styles.hideMenuD, styles.container), id: "#menubar" }, navList));
    }
});

